import React from 'react';

export const ErrorFallback = () => {
  return <div>Oop, có gì đó họat động chưa đúng rồi, vui lòng thử lại.</div>;
};

export default ErrorFallback;
